import { render } from "./customization-location.vue?vue&type=template&id=19db57e0"
import script from "./customization-location.vue?vue&type=script&lang=js"
export * from "./customization-location.vue?vue&type=script&lang=js"

import "./customization-location.vue?vue&type=style&index=0&id=19db57e0&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__